/*
 * Bravo · Cambiar de variante desde el carrito.
 *
 * El tema ya pintaba los desplegables de color o acabado en cada línea del
 * carrito, y hasta dejaba preparado un JSON con todas las variantes del
 * producto. Lo que faltaba era esto: que al cambiarlos pasara algo.
 *
 * Shopify no deja cambiar la variante de una línea existente, así que se añade
 * la nueva y después se quita la vieja. Se hace en ese orden a propósito: si la
 * nueva fallara (por ejemplo, por falta de stock), el carrito se queda como
 * estaba en vez de perder la línea.
 *
 * Las propiedades de la línea (las de Kaching Bundles, por ejemplo) se leen de
 * /cart.js y se vuelven a poner, para no romper los packs.
 */
(function () {
  'use strict';

  if (window.__bravoCartVariant) return;
  window.__bravoCartVariant = true;

  var SELECT = '.cart__item__option-select';

  function ruta(nombre, porDefecto) {
    var r = window.theme && window.theme.routes;
    return ((r && r[nombre]) || porDefecto) + '.js';
  }

  function json(url, opciones) {
    return fetch(url, opciones).then(function (res) {
      return res.json().then(function (d) {
        if (!res.ok) throw new Error((d && (d.description || d.message)) || 'error del carrito');
        return d;
      });
    });
  }

  function grupoDe(select) {
    return select.closest('[data-variant-selects]');
  }

  function selectsDe(grupo) {
    return Array.prototype.slice.call(grupo.querySelectorAll(SELECT)).sort(function (a, b) {
      return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
    });
  }

  function variantesDe(grupo) {
    var tag = grupo.querySelector('script[data-product-variants]');
    if (!tag) return [];
    try {
      return JSON.parse(tag.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function buscaVariante(variantes, elegidas) {
    for (var i = 0; i < variantes.length; i++) {
      var o = variantes[i].opts || [];
      if (o.length !== elegidas.length) continue;
      var igual = true;
      for (var j = 0; j < o.length; j++) {
        if (o[j] !== elegidas[j]) { igual = false; break; }
      }
      if (igual) return variantes[i];
    }
    return null;
  }

  /*
   * Deja sin seleccionar las opciones que, con lo ya elegido en los demás
   * desplegables, no existen o están agotadas.
   */
  function marcaDisponibles(grupo) {
    var selects = selectsDe(grupo);
    var variantes = variantesDe(grupo);
    if (!variantes.length) return;

    selects.forEach(function (sel, idx) {
      Array.prototype.forEach.call(sel.options, function (op) {
        var combina = selects.map(function (s, i) {
          return i === idx ? op.value : s.value;
        });
        var v = buscaVariante(variantes, combina);
        op.disabled = !v || !v.avail;
      });
    });
  }

  function todosLosGrupos() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-variant-selects]'));
  }

  function repasar() {
    todosLosGrupos().forEach(function (g) {
      marcaDisponibles(g);
      selectsDe(g).forEach(function (s) {
        if (!s.dataset.anterior) s.dataset.anterior = s.value;
      });
    });
  }

  function bloquear(grupo, si) {
    selectsDe(grupo).forEach(function (s) { s.disabled = si; });
    grupo.style.opacity = si ? '0.5' : '';
  }

  async function cambiar(select) {
    var grupo = grupoDe(select);
    var linea = select.closest('[data-cart-item]');
    if (!grupo || !linea) return;

    var clave = linea.getAttribute('data-item');
    var elegidas = selectsDe(grupo).map(function (s) { return s.value; });
    var nueva = buscaVariante(variantesDe(grupo), elegidas);

    if (!nueva || !nueva.avail) {
      select.value = select.dataset.anterior || select.value;
      marcaDisponibles(grupo);
      return;
    }

    bloquear(grupo, true);
    try {
      /* De /cart.js salen las unidades y las propiedades de esa línea, que hay
         que conservar al volver a añadirla. */
      var carrito = await json(ruta('cart_url', '/cart'));
      var item = (carrito.items || []).filter(function (i) { return i.key === clave; })[0];
      var unidades = item ? item.quantity : 1;
      var props = (item && item.properties) || {};

      await json(ruta('cart_add_url', '/cart/add'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: nueva.id, quantity: unidades, properties: props}),
      });

      await json(ruta('cart_change_url', '/cart/change'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: clave, quantity: 0}),
      });

      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
    } catch (e) {
      /* No se pudo: se deja el desplegable como estaba y no se toca el carrito. */
      select.value = select.dataset.anterior || select.value;
      bloquear(grupo, false);
      marcaDisponibles(grupo);
      return;
    }
    bloquear(grupo, false);
  }

  /* Delegado en el documento: el carrito se repinta entero a cada cambio. */
  document.addEventListener('change', function (e) {
    var select = e.target.closest ? e.target.closest(SELECT) : null;
    if (select) cambiar(select);
  });

  document.addEventListener('focusin', function (e) {
    var select = e.target.closest ? e.target.closest(SELECT) : null;
    if (select) select.dataset.anterior = select.value;
  });

  ['DOMContentLoaded', 'theme:cart:loaded', 'theme:cart:open', 'theme:cart:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(repasar, 60); });
  });

  if (document.readyState !== 'loading') repasar();
})();
